module.exports = __webpack_public_path__ + "static/img/ch2.32a7019.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ch2.png
// module id = 879
// module chunks = 1